// extracted by mini-css-extract-plugin
module.exports =  {"card":"NewsCard-XOFb__card","hover":"NewsCard-SOt6__hover","hide":"NewsCard-cNjf__hide","news-title":"NewsCard-nRBW__news-title"};